import React, {
  useEffect,
  useState,
} from 'react';

import { usersAPI } from 'api/usersAPI';
import CloseIcon from 'assets/images/icon/CloseIcon';
import { cloneDeep } from 'lodash';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import MembersStep1 from 'view/pages/Members/components/MembersStep1';
import MembersStep2 from 'view/pages/Members/components/MembersStep2';
import MembersStep3 from 'view/pages/Members/components/MembersStep3';

const arr = [1, 2, 3, 4, 5];

const CoPopup = (props) => {
    const [status, setStatus] = useState(0);
    const [selectStep, setSelectStep] = useState("step1");
    const [userData, setUserData] = useState(null);
    const [review, setReview] = useState("");

    const updateUser = async (approve) => {
        await usersAPI.putInstructorInfo(props?.id,{
            data:{
                joinStatus:approve ? "APPROVED" : "PENDING",
                review:review
            }
        })
        .then(res => {
            props?.callback();
            props?.onClickPopup();
        })
    }

    const getInstructorData = async (id) => {
        await usersAPI.getInstructorById(id)
        .then(res => {
            setUserData(cloneDeep(res?.data));
            if(!isEmpty(res?.data?.adminReview)){
                setReview(res?.data?.adminReview)
            }
        })
    };

    const onClickStepBtn = (step) => {
        setSelectStep(step)
    }

    const returnStep = () => {
        switch (selectStep) {
            case "step1":{
                return(<MembersStep1 data={userData} onClickNext={()=>{setSelectStep("step2")}}/>)
            }
            case "step2":{
                return(<MembersStep2 data={userData} onClickNext={()=>{setSelectStep("step3")}} onClickPrev={()=>{setSelectStep("step1")}}  />)
            }
            case "step3":{
                return(<MembersStep3 data={userData} onClickPrev={()=>{setSelectStep("step2")}} />)
            };
        };
    };

    console.log('userData', userData)

    useEffect(()=>{
        getInstructorData(props?.id);
    },[props?.id]);

    return (
        <Container onSubmit={(e)=>{
            e.preventDefault();
        }}>
            <Title>
                <h1>Instructor Application</h1>
            </Title>
            <Dvider />
            <Contents>
                <ContentsItem>
                    {returnStep()}
                </ContentsItem>
                <SubmitItems>
                    <SubmitContents style={{ height: "60%" }}>
                        <StepContainer
                            onClick={()=>{onClickStepBtn("step1")}}
                        className={selectStep === "step1" ? "on" : ""}>
                            <span>Step 1</span>
                            <h2>1. Personal information</h2>
                        </StepContainer>
                        <StepContainer
                          className={selectStep === "step2" ? "on" : ""}
                          onClick={()=>{onClickStepBtn("step2")}}
                        >
                            <span>Step 2</span>
                            <h2>2. Topics</h2>
                        </StepContainer>{" "}
                        <StepContainer
                          className={selectStep === "step3" ? "on" : ""}
                          onClick={()=>{onClickStepBtn("step3")}}
                        >
                            <span>Step 3</span>
                            <h2>3. Qualifications</h2>
                        </StepContainer>
                    </SubmitContents>
                    <SubmitContents style={{ flex: 1, height: "40%", justifyContent: "flex-end" }}>
                        <textarea 
                        value={review}
                        required={true}
                        onChange={(e)=>{
                            setReview(e.target.value)
                        }}
                        placeholder='Admin Review' />
                        {
                            review === "" ? 
                            <Send>
                            <button
                                type='submit'
                               
                                style={{background:"#111"}}
                            >
                                Mark as Pending
                            </button>

                            <button
                                type='submit'

                            >
                                Send
                            </button>
                        </Send>
                        :
                        <Send>
                            <button
                                type='submit'
                                onClick={async () => {
                                    await updateUser(false)
                                }}
                                style={{background:"#111"}}
                            >
                                Mark as Pending
                            </button>

                            <button
                                type='submit'

                                onClick={async () => {
                                await updateUser(true)
                            }}
                            >
                                Send
                            </button>
                        </Send>
                        }
                        
                    </SubmitContents>
                </SubmitItems>
            </Contents>
            <Dvider />

            <CloseButton
                onClick={() => {
                    props.onClickPopup();
                }}
            >
                <CloseIcon />
            </CloseButton>
        </Container>
    );
};
export default CoPopup;

const Container = styled.form`
    display: block;
    position: fixed;
    min-width: 1000px;
    max-height: 90%;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
    position: relative;
    h1 {
        font-size: 28px;
        font-weight: 700;
    }
`;

const Title = styled.div`
    padding: 23px 20px 20px 20px;
`;

const Dvider = styled.div`
    width: 100%;
    background: #333;
    opacity: 0.1;
    height: 1px;
`;

const Contents = styled.div`
    margin-top: 20px;
    padding: 0 20px 20px 20px;
    display: flex;
`;

const CloseButton = styled.div`
    background: #333;
    position: absolute;
    width: 90px;
    cursor: pointer;
    right: 0;
    top: 0;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
        width: 30px;
        height: 30px;
    }
`;

const Rating = styled.div`
    padding: 20px;
    width: 100%;
    h4 {
        font-size: 22px;
        margin-bottom: 15px;
    }
    textarea {
        background: #f5f5f5;
        border: solid 1px #33333330;
        border-radius: 15px;
        width: 100%;
        height: 200px;
        outline: none;
        resize: none;
        padding: 15px;
    }
`;
const Send = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 18px;
    background: #fff;
    span, button {
         font-size: 18px;
        line-height: 1;
        outline: none;
        width: calc((100% - 10px) / 2);
        padding: 18px 0;
        cursor: pointer;
        background: #ddc160;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
         border: none; 
    }
`;
const ContentsItem = styled.div`
    min-width: 60%;
    width: 60%;
    max-width: 60%;
    padding: 20px;
    border: solid 1px #33333320;
    height: calc(100vh - 250px);
    overflow-y: auto;
    border-radius: 10px;
    scrollbar-width: thin;
    scroll-behavior: smooth;
    scrollbar-color: #33333320 transparent;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.5);
        border: none;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;
const SubmitItems = styled.div`
    margin-left: 20px;
    flex: 1;
    textarea {
        resize: none;
        width: 100%;
        border: solid 0.5px rgba(51, 51, 51, 0.3);
        background: #eeeeeeae;
        border-radius: 6px;
        height: 20%;
        margin-bottom: 10px;
    }
`;
const SubmitContents = styled.div`
    display: flex;
    flex-direction: column;
    textarea {
        padding: 15px;
        height: 100%;
    }
`;
const StepContainer = styled.div`
    transition: all 0.1s;
    margin-bottom: 3%;
    display: flex;
    flex-direction: column;
    height: 27%;
    width: 100%;
    border: solid 0.5px rgba(51, 51, 51, 0.2);
    cursor: pointer;
    padding: 10px;
    position: relative;
    h2 {
        position: absolute;
        left: 50%;
        top: 50%;
        font-weight: 500;
        transform: translate(-50%, -50%);
    }
    &.on {
        transition: all 0.2s;

        border: solid 0.5px #ddc160;
        background: #ddc160;
        span {
            font-weight: 700;
            color: #fff;
        }
        h2 {
            font-weight: 700;
            color: #fff;
        }
    }
`;
